import { z } from 'zod';
import {
  extensionEventSchema,
  functionRuntimeSchema,
} from '@rossum/api-client/hooks';

const externalHookInterfaceSchema = z.object({
  name: z.string(),
  description: z.string(),
  payload: z.record(z.string(), z.unknown()).default({}),
  metadata: z.record(z.string(), z.unknown()).default({}),
  type: z.string(),
});

export const externalHookTemplateSchema = z.object({
  events: z.array(extensionEventSchema),
  config: z.object({
    code: z.string().optional(),
    runtime: functionRuntimeSchema,
  }),
  description: z.string(),
  name: z.string(),
  type: z.enum(['function']),
  extension_image_url: z.string(),
  store_description: z.string(),
  hook_interfaces: z.array(externalHookInterfaceSchema).default([]),
});

export type ExternalHookTemplate = z.TypeOf<typeof externalHookTemplateSchema>;
export type ExternalHookInterface = z.TypeOf<
  typeof externalHookInterfaceSchema
>;
